import { render } from "./Indicators.vue?vue&type=template&id=9f28147e&scoped=true"
import script from "./Indicators.vue?vue&type=script&lang=js"
export * from "./Indicators.vue?vue&type=script&lang=js"

import "./Indicators.vue?vue&type=style&index=0&id=9f28147e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9f28147e"

export default script